<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button @click="dismiss">
            <ion-icon slot="icon-only" :icon="icons.close"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>
          {{ title }}
        </ion-title>
      </ion-toolbar>
      <ion-toolbar>
        <ion-searchbar
          v-model="searchText"
          :placeholder="$t('fields.search.label')"
        ></ion-searchbar>
      </ion-toolbar>
    </ion-header>

    <ion-content :fullscreen="true">
      <ion-list style="min-height: 100%">
        <ion-item
          v-for="item in filteredItems"
          :key="item.id"
          button
          @click="onSelect(item)"
          :disabled="item.id === selected"
          :detail="false"
        >
          <ion-avatar v-if="hasLogo && item.logo" slot="start">
            <img :src="item.logo" />
          </ion-avatar>
          <ion-avatar v-if="hasLogo && !item.logo" slot="start">
            <img :src="`${s3Url}/medias/images/icons/icon-logo.png`" />
          </ion-avatar>
          <ion-label>{{ format(item) }}</ion-label>
          <ion-ripple-effect></ion-ripple-effect>
        </ion-item>
        <ion-item v-if="filteredItems.length === 0">
          <ion-label>{{ $t('labels.noContent') }}</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonLabel,
  IonList,
  IonItem,
  IonSearchbar,
  IonRippleEffect,
  IonAvatar,
  modalController,
} from '@ionic/vue';
import { close, search } from 'ionicons/icons';

export default {
  name: 'ModalSelect',
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonLabel,
    IonList,
    IonItem,
    IonSearchbar,
    IonRippleEffect,
    IonAvatar,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    selected: {
      type: Number,
      default: null,
    },
    formatting: {
      type: Function,
      default: null,
    },
    hasLogo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchText: '',
      icons: {
        close,
        search,
      },
    };
  },
  computed: {
    s3Url() {
      return process.env.VUE_APP_S3_URL;
    },
    filteredItems() {
      return this.items.filter((item) =>
        this.format(item).toLowerCase().includes(this.searchText.toLowerCase())
      );
    },
  },
  methods: {
    dismiss() {
      modalController.dismiss();
    },
    onSelect(item) {
      modalController.dismiss(item);
    },
    format(item) {
      if (this.formatting) {
        return this.formatting(item);
      } else {
        return item.name;
      }
    },
  },
};
</script>
